import { HttpClient } from '@angular/common/http';
import { Service, inject } from '@angular/core';

import { Observable, forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Translation, TranslocoLoader } from '@jsverse/transloco';

const I18N_MODULES = [
  'common',
  'auth',
  'home',
  'calendar',
  'booking',
  'rental',
  'image',
  'metrics',
  'not-found',
  'settings',
] as const;

@Service()
export class TranslocoHttpLoader implements TranslocoLoader {
  private readonly _http = inject(HttpClient);

  getTranslation(lang: string): Observable<Translation> {
    const langLower = lang.toLowerCase();

    const requests = I18N_MODULES.map(module =>
      this._http
        .get<Translation>(`/i18n/${langLower}/${module}.json`)
        .pipe(catchError(() => of({} as Translation)))
    );

    return forkJoin(requests).pipe(map(modules => Object.assign({}, ...modules) as Translation));
  }
}
